module.exports = __webpack_public_path__ + "img/reportes.7f3bb149.gif";